import React from "react";
import Image from "next/image";
import { AspectRatio, Box, Flex, Text } from "@chakra-ui/react";
import { LinkCard } from "ui/link-card";
import { ArrowLink } from "ui/link";

type QuoteCardProps = {
  bg: string;
  logo: string;
  quote: string;
  author: string;
  job: string;
  company: string;
  href: string;
  hasBorder?: boolean;
};

export function QuoteCard({ bg, logo, quote, author, job, company, href, hasBorder }: QuoteCardProps) {
  return (
    <LinkCard
      href={href}
      linkAriaLabel={`Read ${company} case study.`}
      width="100%"
      border={hasBorder ? "1px" : "none"}
      borderColor="base.border"
      bg="white"
      borderRadius="xl"
      p={0}
      overflow="hidden"
      maxW={{ base: "md", md: "100%" }}
      mx="auto"
      transition=".15s all ease-in-out"
      _hover={hasBorder ? { borderColor: "gray.400" } : undefined}
    >
      <AspectRatio pos="relative" ratio={3 / 2} width="100%" maxHeight={{ base: "200px", md: "230px" }} bg={bg}>
        <Flex pos="absolute" inset={0} align="center" justify="center" filter="brightness(0) invert(1)">
          <Flex align="center" justify="center" pos="relative" w="50%" h="50%" maxW={{ base: "180px", md: "100%" }}>
            <Image
              src={logo + "?w=400"}
              alt={company + "."}
              width={200}
              height={40}
              style={{
                objectFit: "contain",
                width: "100%",
                height: "auto",
              }}
            />
          </Flex>
        </Flex>
      </AspectRatio>

      <Flex
        align="start"
        direction="column"
        justify="space-between"
        h="100%"
        p={{ base: 7, xl: 9 }}
        pb={{ base: 10, xl: 12 }}
      >
        <Box>
          <Text fontSize={{ base: "md", sm: "lg" }}>&quot;{quote}&quot;</Text>

          <Text flex={1} fontSize={{ base: "sm", sm: "md" }} fontWeight="semibold" mt={5}>
            {author}
            <br />
            <Text as="span" fontSize={{ base: "xs", sm: "sm" }} fontWeight="normal">
              {job}, {company}
            </Text>
          </Text>
        </Box>

        <ArrowLink as="div" variant="grass" size={{ base: "md", lg: "lg" }} pt={9} mt="auto">
          Read case study
        </ArrowLink>
      </Flex>
    </LinkCard>
  );
}
